import { Injectable } from '@angular/core';
import { projectConfig } from '@app/core/configs/project.config';
import { CustomTheme, DefaultTheme, Theme } from '@app/models';
import { BehaviorSubject } from 'rxjs';

const themes: Theme[] = [
  DefaultTheme.LIGHT,
  DefaultTheme.DARK,
  CustomTheme.ARGO,
  CustomTheme.MyJokes,
  CustomTheme.StreetFair,
  CustomTheme.Abraham,
  CustomTheme.grandaddy,
  CustomTheme.drjenniferashuy,
  CustomTheme.khruanguin,
  CustomTheme.dharmann,
];

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private theme = new BehaviorSubject<Theme>(DefaultTheme.LIGHT);
  theme$ = this.theme.asObservable();

  setTheme(theme: Theme): void {
    this.theme.next(theme);
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }

  toggleTheme(theme: Theme): void {
    this.setTheme(theme);
  }

  initializeTheme(): void {
    const urlTheme = this.getThemeFromUrl();
    if (urlTheme) {
      this.setTheme(urlTheme);
      return;
    }

    const savedTheme = localStorage.getItem('theme') as Theme | null;
    if (savedTheme && themes.includes(savedTheme)) {
      this.toggleTheme(savedTheme);
      return;
    }

    this.toggleTheme(projectConfig.defaultTheme);
  }

  private getThemeFromUrl(): Theme | null {
    const params = new URLSearchParams(window.location.search);
    const urlTheme = params.get('theme')?.toLowerCase();

    if (themes.includes(urlTheme as Theme)) {
      return urlTheme as Theme;
    }

    return null;
  }
}
